export const ngn = (n) => `₦${Number(n || 0).toLocaleString("en-NG", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
export const usd = (cents) => `$${(Number(cents || 0) / 100).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
export const shortDate = (iso) => (iso ? new Date(iso).toLocaleDateString(undefined, { day: "numeric", month: "short", year: "numeric" }) : "—");

export const PUBLISHING_STATES = [
  { value: "ready", label: "Ready for Publishing" },
  { value: "public", label: "Public" },
  { value: "coming_soon", label: "Coming Soon" },
  { value: "premiering", label: "Premiering" },
  { value: "festival_run", label: "Festival Run" },
];

export const REGION_LABELS = {
  local: "Nigeria (Local)",
  african: "African",
  diaspora: "Diaspora",
  unknown: "Unknown",
};

export const EMPTY_BUCKET = { count: 0, gross: 0, platform: 0 };

export const SectionHeading = ({ eyebrow, title, description, action }) => (
  <div className="flex flex-wrap items-end justify-between gap-4 mb-6">
    <div>
      {eyebrow && <p className="text-[11px] uppercase tracking-[0.25em] text-terracotta font-semibold mb-1">{eyebrow}</p>}
      <h2 className="font-display text-2xl sm:text-3xl font-black">{title}</h2>
      {description && <p className="text-sm text-foreground/60 mt-1 max-w-2xl">{description}</p>}
    </div>
    {action}
  </div>
);

export const MetricCard = ({ label, value, hint, icon: Icon, tone = "text-foreground", testId, accent = false }) => (
  <div
    className={`p-5 rounded-xl border transition-colors ${accent ? "bg-gradient-to-br from-terracotta/20 via-gold/5 to-transparent border-terracotta/40" : "bg-surface border-white/10 hover:border-white/20"}`}
    data-testid={testId}
  >
    <div className="flex items-start justify-between gap-2 mb-3 text-foreground/55 min-h-[30px]">
      <span className="text-[11px] uppercase tracking-wider font-medium leading-snug">{label}</span>
      {Icon && <Icon className="w-4 h-4 shrink-0" />}
    </div>
    <p className={`font-display text-2xl font-black tabular-nums ${tone}`} data-testid={testId ? `${testId}-value` : undefined}>{value}</p>
    {hint && <p className="text-[11px] text-foreground/45 mt-1.5">{hint}</p>}
  </div>
);

export const DataTable = ({ headers, children, empty, testId, colSpan }) => (
  <div className="overflow-x-auto rounded-xl border border-white/10" data-testid={testId}>
    <table className="w-full text-sm">
      <thead className="bg-surface text-left text-foreground/55 text-[11px] uppercase tracking-wider">
        <tr>{headers.map((h) => <th key={h} className="p-3 font-medium whitespace-nowrap">{h}</th>)}</tr>
      </thead>
      <tbody className="divide-y divide-white/5">
        {children}
        {empty && (
          <tr><td colSpan={colSpan || headers.length} className="p-6 text-center text-foreground/45 text-sm">{empty}</td></tr>
        )}
      </tbody>
    </table>
  </div>
);
